export default __webpack_public_path__ + "9e039c529b3e494d2cdcf1aa84849da4.png";